import { useState } from "react";
import { calendarService } from "@miplatform/api";
import {
  IApiRequest,
  ITenantHolidayGroupedResponse,
  ITenantHolidayResponse,
} from "@miplatform/types";

export interface ITenantHolidayWithYear extends ITenantHolidayResponse {
  year: number;
}

export const useTenantHolidays = () => {
  const [tenantHolidays, setTenantHolidays] = useState<
    ITenantHolidayWithYear[]
  >([]);

  const getTenantHolidays = async (config: IApiRequest = {}) => {
    const response = await calendarService.tenantHolidays.getAllGrouped(config);

    const flat: ITenantHolidayWithYear[] = (response.data || []).flatMap(
      (group: ITenantHolidayGroupedResponse) => {
        const sortedHolidays = group.holidays.sort(
          (a, b) =>
            new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
        );

        return sortedHolidays.map((h: ITenantHolidayResponse) => ({
          ...h,
          year: group.year,
        }));
      }
    );

    return {
      ...response,
      data: flat,
      headers: {
        totalcount: String(flat.length),
        totalpages: "1",
      },
    };
  };

  return {
    tenantHolidays,
    loading: false,
    getTenantHolidays,
    setTenantHolidays,
  };
};
